/*!
 * This file was created to only avoid "values imports" (constants/enums/classes/etc.) from the `bitmovin-player@8.233.0`
 * to avoid including the whole package in our distribution code.
 *
 * We should still use "type imports" (`import type {}`) from the library!
 *
 * Unit test should cover "copies of the library values" to be sure they are up to date with the library!
 */

/* eslint-disable perfectionist/sort-enums */

/**
 * Copy of `HttpRequestType` enum from Bitmovin Player
 *
 * @see https://github.com/bitmovin-engineering/bitdash/blob/v8.233.0/src/core/NetworkAPI.ts#L11
 */
export enum HttpRequestType {
  MANIFEST_DASH = 'manifest/dash',
  MANIFEST_HLS_MASTER = 'manifest/hls/master',
  MANIFEST_HLS_VARIANT = 'manifest/hls/variant',
  MANIFEST_SMOOTH = 'manifest/smooth',
  MANIFEST_ADS = 'manifest/ads',

  MEDIA_AUDIO = 'media/audio',
  MEDIA_VIDEO = 'media/video',
  MEDIA_SUBTITLES = 'media/subtitles',
  MEDIA_THUMBNAILS = 'media/thumbnails',
  MEDIA_SEGMENTINDEX = 'media/segmentindex',

  DRM_LICENSE_WIDEVINE = 'drm/license/widevine',
  DRM_LICENSE_PLAYREADY = 'drm/license/playready',
  DRM_LICENSE_FAIRPLAY = 'drm/license/fairplay',
  DRM_LICENSE_PRIMETIME = 'drm/license/primetime',
  DRM_LICENSE_CLEARKEY = 'drm/license/clearkey',
  DRM_LICENSE_TVKEY = 'drm/license/tvkey',

  DRM_CERTIFICATE_FAIRPLAY = 'drm/certificate/fairplay',

  HLS_INTERSTITIALS_ASSET_LIST = 'hls/interstitials/asset-list',

  KEY_HLS_AES = 'key/hls/aes',

  TIME_SYNC = 'time/sync',

  WEBRTC_SDP_REQUEST = 'webrtc/sdp/request',
  WEBRTC_SDP_ANSWER = 'webrtc/sdp/answer',
  WEBRTC_SDP_OFFER = 'webrtc/sdp/offer',

  UNKNOWN = 'unknown',

  INTERNAL = 'internal',
}

/* eslint-enable perfectionist/sort-enums */
